import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function VerifyEmail() {
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      setStatus("error");
      setMessage("Missing verification token.");
      return;
    }
    axios
      .get(`${API_URL}/auth/verify`, { params: { token } })
      .then((res) => {
        setStatus("success");
        setMessage(res.data?.email ? `${res.data.email} is now verified.` : "Your email is verified.");
        // Keep this browser's session in sync if it's the same user
        try {
          const saved = JSON.parse(localStorage.getItem("oryyn_user") || "null");
          if (saved && res.data?.email && saved.email === res.data.email) {
            saved.is_verified = true;
            localStorage.setItem("oryyn_user", JSON.stringify(saved));
          }
        } catch {
          /* ignore */
        }
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Verification failed.");
      });
  }, []);

  const icon = status === "success" ? "✅" : status === "error" ? "⚠️" : "⏳";
  const heading =
    status === "success"
      ? "Email verified!"
      : status === "error"
      ? "Couldn't verify"
      : "Verifying…";

  return (
    <div className="verify-page">
      <div className="verify-card">
        <div className="verify-icon">{icon}</div>
        <h1 className="verify-heading">{heading}</h1>
        <p className="verify-message">{message}</p>
        {status !== "loading" && (
          <a className="verify-button" href="/">
            Go to Oryyn
          </a>
        )}
      </div>
    </div>
  );
}
